import PropTypes from 'prop-types';

import React from 'react';
import { connect } from 'react-redux';
import { Field, reduxForm, formValueSelector } from 'redux-form';
import Immutable, { Map, List } from 'immutable'; // eslint-disable-line

import immutableCreatorSelector from '../../selectors/immutableCreatorSelector';
import { validateAndDispatch } from '../../helpers/form';
import NavBarLoggedOut from '../../components/NavBarLoggedOut';
import { UserActions } from '../../actions/user';
import '../../styles/Dashboard.css';

const forgotPasswordFormSelector = (state) => {
  const selector = formValueSelector('forgotPassword');
  return selector(state, 'email');
};

const ForgotPasswordSelector = immutableCreatorSelector(
  [forgotPasswordFormSelector],
  (forgotPasswordForm) => {
    return {
      fields: {
        email: forgotPasswordForm
      }
    }
  }
);

@connect(ForgotPasswordSelector)
@reduxForm({
  form: 'forgotPassword'
})
class ForgotPassword extends React.Component {
  static propTypes = {
    dispatch: PropTypes.func.isRequired,
    fields: PropTypes.object.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    submitting: PropTypes.bool.isRequired
  }

  submit = (values, dispatch) => {
    const validation = {
      email: [{ rule: 'required', label: 'email' }, 'email'],
    };

    return validateAndDispatch(
      dispatch,
      UserActions.forgotPassword(values.email),
      validation,
      values
    );
  }

  render() {
    const {
      handleSubmit,
      submitting
    } = this.props;

    return (
      <div className="main-container">
        <NavBarLoggedOut />
        <div className="row">
          <div className="col-md-12">
            <h2>Forgot Password</h2>
            <form onSubmit={handleSubmit(this.submit)}>
              <fieldset className="form-group">
                <label htmlFor="email">Email Address</label>
                <Field name="email" component="input" type="text" className="form-control" placeholder="Email Address" autoFocus="true" />
              </fieldset>
              <button type="submit" className="btn btn-primary" disabled={submitting}>
                {submitting && <i className="fa fa-cog fa-spinner fa-spin"></i>} Reset Password
              </button>
            </form>
          </div>
        </div>
      </div>
    );
  }
}

@connect(_state => ({
}))
export default class ForgotPasswordContainer extends React.Component {
  static propTypes = {
    dispatch: PropTypes.func.isRequired
  }

  render() {
    const { dispatch } = this.props;
    return (
      <ForgotPassword dispatch={dispatch} {...this.props} />
    );
  }
}



// WEBPACK FOOTER //
// ./src/views/public/ForgotPassword.js